import Home from './home';
import About from './about';
import Film from './film';
import Sports from './sports';
import Services from './services';
import Comm from './comm';
import Device from './device';
import Review from './review';
import Faq from './faq';
import FootballPromoBanner from '../components/FootballPromoBanner';

export default function Accueil() {
    return (
        <>
        <Home/>
        <About/>
        <Film/>
        <Services/>
        <Sports/>
        <section style={{backgroundColor: 'var(--bg-color)'}} className="py-6">
            <div className="main-content">
                <FootballPromoBanner />
            </div>
        </section>

        <Comm/>
        <Device/>
        <Review/>
        <Faq/>
        </>
    )
}
